import { useState } from 'react';
import { comics, comicCategories } from '@/mocks/comic';

export default function Recommendations() {
  const [active, setActive] = useState('全部');
  const filtered = active === '全部' ? comics : comics.filter((c) => c.category === active);

  return (
    <section id="recommend" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div className="max-w-xl">
            <span className="inline-block rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-900">
              热门推荐
            </span>
            <h2 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
              最近大家都在追
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              分卷整理、章节目录直达，口碑与热度双高的作品一网打尽。
            </p>
          </div>

          <div className="flex flex-wrap gap-2">
            {comicCategories.map((c) => (
              <button
                key={c}
                type="button"
                onClick={() => setActive(c)}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                  active === c
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-50 text-foreground-600 hover:bg-background-200'
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {filtered.map((comic) => (
            <article
              key={comic.id}
              className="group flex gap-4 rounded-2xl border border-background-200 bg-background-50 p-4"
            >
              <div className="relative h-[150px] w-[106px] shrink-0 overflow-hidden rounded-xl">
                <img
                  src={comic.cover}
                  alt={`${comic.title}漫画封面`}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
                <span className="absolute left-1.5 top-1.5 rounded-md bg-foreground-950/70 px-2 py-0.5 text-xs font-bold text-background-50">
                  {comic.rating}
                </span>
              </div>
              <div className="flex min-w-0 flex-1 flex-col">
                <h3 className="truncate font-heading text-lg font-bold text-foreground-950">{comic.title}</h3>
                <p className="mt-0.5 text-xs text-foreground-500">{comic.author}</p>
                <div className="mt-2 flex flex-wrap gap-1.5">
                  {comic.tags.map((t) => (
                    <span
                      key={t}
                      className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-900"
                    >
                      {t}
                    </span>
                  ))}
                </div>
                <div className="mt-auto flex items-center justify-between pt-3">
                  <span className="text-xs text-foreground-500">
                    {comic.chapters} 话 · {comic.status}
                  </span>
                  <a
                    href="#volumes"
                    className="flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-50 px-3 py-1 text-xs font-semibold text-primary-700 transition-colors hover:bg-primary-500 hover:text-background-50"
                  >
                    直达
                    <i className="ri-arrow-right-line" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}